import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { CatalogSourcesDetailLoader } from '~/components/ContentSources';
import { environment } from '~/util/environment';

function RedirectToStorybook() {
  window.location.href = environment.storybookDevelopmentUrl;
  return <span className="text-muted">Redirecting to { environment.storybookDevelopmentUrl }...</span>;
}

const Dashboard = lazy( () => import( '~/components/lazy/Dashboard' ) );
const ContentSources = lazy( () => import( '~/components/lazy/ContentSources' ) );
const ContentStreamingRightsLoader = lazy( () => import( '~/components/lazy/ContentStreamingRightsLoader' ) );
const TrackDetailsLoader = lazy( () => import( '~/components/lazy/TrackDetailsLoader' ) );
const AvailabilityReview = lazy( () => import( '~/components/lazy/AvailabilityReview' ) );
const BulkReplace = lazy( () => import( '~/components/lazy/BulkReplace' ) );
const Catalog = lazy( () => import( '~/components/lazy/Catalog' ) );
const Placement = lazy( () => import( '~/components/lazy/Placement' ) );
const Application = lazy( () => import( '~/components/lazy/Application' ) );
const Playlist = lazy( () => import( '~/components/lazy/Playlist' ) );
const StationV2Page = lazy( () => import( '~/components/lazy/StationV2Page' ) );
const User = lazy( () => import( '~/components/lazy/User' ) );
const Analytics = lazy( () => import( '~/components/lazy/Analytics' ) );
const StationImport = lazy( () => import( '~/components/lazy/StationImport' ) );
const ApplicationStationsPage = lazy( () => import( '~/components/lazy/ApplicationStationsPage' ) );
const DeveloperTools = lazy( () => import( '~/components/lazy/DeveloperTools' ) );
const MissingPage = lazy( () => import( '~/components/lazy/MissingPage' ) );
const FiltersPage = lazy( () => import( '~/components/lazy/FiltersPage' ) );
const BulkUploadPage = lazy( () => import( '~/components/lazy/BulkUploadPage' ) );
const CuratedStationsPage = lazy( () => import( '~/components/lazy/CuratedStationsPage' ) );
const PublishingPage = lazy( () => import( '~/components/lazy/PublishingPage' ) );
const ReportPage = lazy( () => import( '~/components/lazy/ReportPage' ) );
const ReportsListPage = lazy( () => import( '~/components/lazy/ReportsListPage' ) );
const HomePage = lazy( () => import( '~/components/lazy/HomePage' ) );
const ClipsCustomersPage = lazy( () => import( '~/components/lazy/ClipsCustomersPage' ) );
const ClipsCollectionSortingPage = lazy( () => import( '~/components/lazy/ClipsCollectionSortingPage' ) );
const RolesPage = lazy( () => import( '~/components/lazy/RolesPage' ) );

const _routes = (
  <Switch>
    <Route path="/dashboard" component={ Dashboard } />
    <Route path="/content/sources/:sourceId" component={ CatalogSourcesDetailLoader } />
    <Route path="/content/sources" component={ ContentSources } />
    <Route path="/content/streaming-rights" component={ ContentStreamingRightsLoader } />
    <Route path="/content/tracks/:trackId" component={ TrackDetailsLoader } />
    <Route path="/content/tracks" component={ TrackDetailsLoader } />
    <Route path="/availability-review/:method" component={ AvailabilityReview } />
    <Route path="/bulk-replace/:audioFileId" component={ BulkReplace } />
    <Route path="/catalog/search" component={ Catalog } />
    <Route path="/catalog" component={ () => <Redirect to="/catalog/search" /> } />
    <Route path="/placements/:placementKey" component={ Placement } />
    <Route path="/application/:applicationId/:placementKey" component={ Placement } />
    <Route path="/application/:applicationId/" strict component={ Application } />
    <Redirect from="/application/:applicationId" to="/application/:applicationId/" />
    <Route path="/library*" render={ () => <RedirectToStorybook /> } />
    <Route path="/playlist/:playlistId" component={ Playlist } />
    <Route path="/stationV2/:stationId" component={ StationV2Page } />
    <Route path="/user/:id" component={ User } />
    <Route path="/analytics/:report?" component={ Analytics } />
    <Route path="/appstation/:applicationId/import" component={ StationImport } />
    <Route path="/appstation/:applicationId" component={ ApplicationStationsPage } />
    <Route path="/developer-tools" component={ DeveloperTools } />
    <Route path="/filters" component={ FiltersPage } />
    <Route path="/bulk-upload" component={ BulkUploadPage } />
    <Route path="/curated-stations" component={ CuratedStationsPage } />
    <Route path="/publishing" component={ PublishingPage } />
    <Route path="/report" exact component={ ReportsListPage } />
    <Route path="/report/:reportId" component={ ReportPage } />
    <Route path="/home" component={ HomePage } />
    <Route path="/clips/customers" component={ ClipsCustomersPage } />
    <Route path="/clips/collections/sort" component={ ClipsCollectionSortingPage } />
    <Route path="/roles" component={ RolesPage } />
    <Redirect path="/" to="/home" />

    <Route component={ MissingPage } />
  </Switch>
);

export const Routes = () => _routes;

Routes.displayName = 'Routes';
